import React from "react";
import { Form, Icon, Input, Checkbox, Radio, Select } from "antd";
import get from "lodash/get";

import PatientElectronicText from "./Texts/PatientElectronicText";
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";
import { withNamespaces } from "react-i18next";
import FormBuilderCustomView from "../../containers/FormBuilder/FormBuilderCustomView";
import {getBackendConsentType} from "../../utils/consentUtils";

const { Option } = Select;

class ConsentStep3aPatient extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    // by_person_settings.patient.consent_types.consent_patient_form.electronic.form
    // by_person_settings.patient.consent_types.consent_patient_form.electronic.form
    const backEndType = getBackendConsentType(props.consentPersonType, props.consentMethodType);
    let methodType = 'electronic';
    if (props.consentMethodType.toLowerCase().includes('email')){
      methodType = 'email';
    }
    if (props.consentMethodType.toLowerCase().includes('paper')){
      methodType = 'paper';
    }
    let formSchema = '';
    let content = '';
    if (!get(props, 'languageCode')){
      formSchema = this.props.ui_form || get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.${methodType}.form`);
      content = this.props.ui_content || get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.${methodType}.content`);
    }else{
      formSchema = this.props.ui_form || get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.languages.${props.languageCode}.${methodType}.form`);
      content = this.props.ui_content || get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.languages.${props.languageCode}.${methodType}.content`);
    }

    // TODO error out gracefully if formSchema and content are empty, just dont show anything without breaking


    const initial_form_data = get(this.props, 'initial_form_data', undefined);

    let isEmail = false;
    let isAfterDeferral = false;
    if (props.consentMethodType){
      isEmail = props.consentMethodType.includes('Email');
      isAfterDeferral = props.consentMethodType.includes('AfterDeferral');
    }

    const showForEmail = !(isEmail && !props.token);
    const isPatient = props.consentPersonType === "Patient";
    const isEmergency = props.consentPersonType === "Emergency";
    const isSurrogate = props.consentPersonType === "Surrogate";
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";
    const isInvestigatorFirst = props.email_consent_signature_order === "investigator_first";
    const isEmailParticipant = props.signature_type === "participant";
    const isEmailInvestigator = props.signature_type === "investigator";

    let preNameOfParticipant = '';
    let NameOfParticipant = props.i18n.t('NamespaceConsent:Name of Participant');
    let SignatureOfParticipant = props.i18n.t('NamespaceConsent:Signature of Participant');
    let NameOfSurrogate = props.i18n.t('NamespaceConsent:Name of Surrogate');
    let SignatureOfSurrogate = props.i18n.t('NamespaceConsent:Signature of Surrogate');
    let RelationshiptoParticipant = props.i18n.t('NamespaceConsent:Relationship to Participant');
    let NameofPersonObtainingConsent = props.i18n.t('NamespaceConsent:Name of Person Obtaining Consent');
    let SignatureOfPersonObtainingConsent = props.i18n.t('NamespaceConsent:Signature of Person Obtaining Consent');

    let QuestionNr1Text = props.i18n.t('NamespaceConsent:CONSENT TO CONTACT YOU IF RESEARCHERS DISCOVER SOMETHING ABOUT YOU:');
    if (isSurrogate){
      QuestionNr1Text = props.i18n.t('NamespaceConsent:CONSENT TO CONTACT IF RESEARCHERS DISCOVER SOMETHING ABOUT YOUR FAMILY MEMBER:');
    }


    return (
      <div className="form-group consent-form-ui">
        <style>
          {".consent-form-ui h1, h2, h3, h4, h5, h6 {text-transform: none;}"}
        </style>
        <h4>
          {props.signature_type === "investigator"
            ? this.props.i18n.t(
                "NamespaceConsent:Consent Process - Investigator"
              )
            : props.consentPersonType === "Surrogate"
            ? this.props.i18n.t(
                "NamespaceConsent:Consent Process - Surrogate"
              )
            : props.consentPersonType === "Patient"
            ? this.props.i18n.t(
                "NamespaceConsent:Consent Process - Patient"
              )
            : props.consentPersonType === "Emergency"
            ? this.props.i18n.t(
                "NamespaceConsent:Consent Process - Emergency"
              )
            : ""}
        </h4>

        <div className="form-group-details">
          {props.siteID && (
            <h5>
              {this.props.i18n.t("NamespaceConsent:Site ID")}: <b>{props.siteID}</b>
            </h5>
          )}
          {props.userID && (
            <h5>
              {this.props.i18n.t("NamespaceConsent:User ID")}: <b>{props.userID}</b>
            </h5>
          )}
          <h5>
            {this.props.i18n.t("NamespaceConsent:Subject ID")}: <b>{props.subjectID}</b>
          </h5>
        </div>

        <PatientElectronicText content={content} />

        <p>
          <strong>
            {this.props.i18n.t("NamespaceConsent:Server Date (UTC)")}:{" "}
            {props.date || props.consentDate}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("NamespaceConsent:Consent Type")}: {props.consentPersonType}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("NamespaceConsent:Consent Method")}: {props.consentMethodType}
          </strong>
        </p>
        <p>&nbsp;</p>

        <div style={{ textAlign: "left" }}>
          <FormBuilderCustomView
            initialValues={initial_form_data}
            saveButton={this.props.i18n.t('NamespaceConsent:Next')}
            backStep={this.props.backStep}
            isEditable={true}
            schema={formSchema}
            name={''}
            onSubmit={this.props.handleSubmitBuildForm}
          />
        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentStep3aPatient);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeHope_ii_V2_1Update/ConsentStep3aPatient.js